import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddFarmPurchaseModal({ onClose, onSuccess }) {
  const [brokerName, setBrokerName] = useState('');
  const [quantity, setQuantity] = useState('');
  const [rate, setRate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const total = parseFloat(quantity) * parseFloat(rate);
    try {
      await axios.post(`${API_URL}/add-farm-purchase`, {
        broker_name: brokerName,
        quantity_kg: parseFloat(quantity),
        farm_rate: parseFloat(rate),
        total_amount: total,
        recorded_by: localStorage.getItem('userId')
      });
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding purchase: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Add Farm Purchase</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Broker Name" value={brokerName} onChange={(e) => setBrokerName(e.target.value)} required />
          <input type="number" step="0.01" placeholder="Quantity (kg)" value={quantity} onChange={(e) => setQuantity(e.target.value)} required />
          <input type="number" step="0.01" placeholder="Rate per kg" value={rate} onChange={(e) => setRate(e.target.value)} required />
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Adding...' : 'Add Purchase'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddFarmPurchaseModal;